import React, { useState, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import UserContext from "./context/UserContext";
import { TourProvider } from "@reactour/tour";

import api from "./services/api";

import Header from "./components/Header";
import Routes from "./routes";

import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";

export default function App() {

  const [userData, setUserData] = useState({
    token: undefined,
    user: undefined,
  });
  // const location = useLocation();

  useEffect(() => {
    const checkLoggedIn = async () => {
      let token = localStorage.getItem("auth-token");

      if (token === null) {
        localStorage.setItem("auth-token", "");
        localStorage.setItem("ata-id", "");
        localStorage.setItem("versao-id", "");
        token = "";
      }

      const tokenRes = await api.post("/api/user/verify-token", null, {
        headers: { "x-auth-token": token },
      });

      if (tokenRes.data) {
        const userRes = await api.get("/api/user/perfil", {
          headers: { "x-auth-token": token },
        });

        setUserData({
          token,
          user: userRes.data,
        });
      } else {
        return (window.location.href = "/");
      }
    };
    if (
      window.location.pathname !== "/" &&
      !window.location.pathname.includes("/login")
    ) {
      // return window.location.href = '/';
    }
    if (window.location.pathname !== "/") checkLoggedIn();
  }, []);

  return (
    <TourProvider

      steps={[]}
      onClickClose={({ setCurrentStep, setIsOpen }) => {
        setIsOpen(false);
        setCurrentStep(0)
      }}
      styles={{
        popover: (base) => ({
          ...base,
          "--reactour-accent": "#4260FF",
          borderRadius: 10,
          textAlign: "center",
          paddingTop: "3rem",
          boxShadow:
            "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
        }),
        maskArea: (base) => ({ ...base, rx: 10 }),
        maskWrapper: (base) => ({ ...base, color: "#000", opacity: 0.5 }),
        badge: (base) => ({
          ...base,
          right: "auto",
          left: "-0.8125em",
        }),
        controls: (base) => ({
          ...base,
          marginTop: 25,
        }),
      }}
    >
      <UserContext.Provider value={{ userData, setUserData }}>
        <BrowserRouter>
          {window.location.pathname !== "/" && <Header user={userData?.user} />}

          <Routes />
        </BrowserRouter>
      </UserContext.Provider>
    </TourProvider>
  );
}
